<template>
  <div>
    <v-client-table :columns="columns" :data="items" :options="options">
      <div v-if="props.row.created_at" slot="created_at" slot-scope="props">
        <span class="badge badge-success p-2">{{ getFormattedDateTime(props.row.created_at) }}</span>
      </div>
      <div slot="gestionnaire" slot-scope="props">
        <span v-if="!isEmpty(props.row.gestionnaire)">{{ props.row.gestionnaire.prenom }} {{ props.row.gestionnaire.nom }}</span>
        <span v-else>N.D</span>
      </div>
    </v-client-table>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth';
  import { isEmpty } from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "Journal",
    data() {
      return {
        items: [],
        isEmpty,
        columns: [
          "created_at",
          "gestionnaire",
          "action",
          "commentaire",
        ],
        options: {
          headings: {
            created_at: "Date",
            gestionnaire: "Gestionnaire",
            action: "Action",
            commentaire: "Détail",
          },
          filterable: ['gestionnaire.nom','gestionnaire.prenom','action','commentaire'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Gestionnaire, Action, Détail"
          },
        },
      }
    },
    props: [
      'siren',
      'journalItems',
    ],
    mounted() {
      this.items = this.journalItems;
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider();
      this.$event.on('changeSirenPreferences', (data) => {
        this.items = data;
      });
    },
    methods: {
      getFormattedDateTime(textDate) {
        return formatDateTime(textDate, '/');
      },
    }
  }
</script>

<style scoped>

</style>
